import Preference from './Preference';

export default Preference;
